<template>
<div>
  <v-text-field :readonly="editMode" :disabled="editMode" :label="field.name" @click="onPickFile" v-model='fileName' prepend-icon="attach_file"></v-text-field>
  <input type="file" style="display: none" ref="fileInput" accept="*/*" @change="onFilePicked">
</div>
</template>

<script>
import {
  input
} from '@/mixins/input'
export default {
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  data() {
    return {
      fileName: "",
      editMode: false
    }
  },
  methods: {
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }

        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.model = fr.result.split(';base64,')[1];
          this.fileName = files[0].name
        })

      } else {
        this.fileName = ''
        this.model = ""
      }
    }
  },
  mounted() {

  },
  created() {
    this.model = this.value
    if (this.value != undefined && this.value.customName != undefined) {
      this.fileName = this.value.customName
      this.editMode = true
    }
  },
  mixins: [input]
}
</script>

<style>

</style>
